
export enum RestauranteStatus {
    ATIVO = "Ativo",
    INATIVO = "Inativo",
    INATIVO_ADMIN = "Inativo pelo administrador",
    PENDENTE = "Pendente"
}